/* eslint-disable header/header */ export const Web3PkgInfo = { version: '0.3.0' };
